// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "productpg/" + {"189":"page-mixAndMatch","404":"page-singleProduct","406":"deferred"}[chunkId] + "." + {"189":"03e38b6b16d8e7751d3c","404":"5cf8f4954798c988c57d","406":"d42840d8595f53102289"}[chunkId] + ".css";
};